import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AppFooterPresenter } from './app-footer.presenter';
import { AbstractView } from '@core/interfaces';
import { Store } from '@ngrx/store';
import { DialogTermConditionComponent } from '../../../views/pages/auth/login/components/dialog-term-condition/dialog-term-condition.component';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [DialogTermConditionComponent],
  templateUrl: './app-footer.component.html',
  styleUrl: './app-footer.component.scss',
})
export class AppFooterComponent
  extends AbstractView<AppFooterPresenter>
  implements OnInit
{
  environmentName = this.presenter.environmentName;
  environmentVersion = this.presenter.environmentVersion;
  currentYear = this.presenter.currentYear;
  @ViewChild(DialogTermConditionComponent)
  dialogTermConditionComponent!: DialogTermConditionComponent;

  constructor(
    messageService: MessageService,
    router: Router,
    store: Store,
    presenter: AppFooterPresenter
  ) {
    super(messageService, router, store, presenter);
  }

  ngOnInit(): void {
    this.presenter.setView(this);
  }

  toggleDialogTermCondition(event: boolean, previewDialog = true): void {
    this.dialogTermConditionComponent.toggleDialog(event, previewDialog);
  }
}
